import authApi from '@/api/auth'

const TOKEN_KEY = 'mob_access_token'
const USER_KEY = 'mob_user'

export default {
  namespaced: true,

  state: () => ({
    accessToken: localStorage.getItem(TOKEN_KEY) || null,
    user: JSON.parse(localStorage.getItem(USER_KEY) || 'null')
  }),

  getters: {
    accessToken: s => s.accessToken,
    user: s => s.user,
    isAuthenticated: s => !!s.accessToken,
    userId: s => s.user?.userId || null
  },

  mutations: {
    SET_TOKEN (state, token) {
      state.accessToken = token
      if (token) localStorage.setItem(TOKEN_KEY, token)
      else localStorage.removeItem(TOKEN_KEY)
    },
    SET_USER (state, user) {
      state.user = user
      if (user) localStorage.setItem(USER_KEY, JSON.stringify(user))
      else localStorage.removeItem(USER_KEY)
    }
  },

  actions: {
    async login ({ commit }, credentials) {
      const { data } = await authApi.login(credentials)
      commit('SET_TOKEN', data.accessToken)
      const profile = await authApi.getCurrentUser()
      commit('SET_USER', profile.data)
      return data
    },

    async register (_, payload) {
      const { data } = await authApi.register(payload)
      return data
    },

    async verifyAccount ({ commit }, payload) {
      const { data } = await authApi.verifyAccount(payload)
      commit('SET_TOKEN', data.accessToken)
      const profile = await authApi.getCurrentUser()
      commit('SET_USER', profile.data)
      return data
    },

    async refreshToken ({ commit }) {
      const { data } = await authApi.refreshToken()
      commit('SET_TOKEN', data.accessToken)
      return data
    },

    logout ({ commit }) {
      commit('SET_TOKEN', null)
      commit('SET_USER', null)
    }
  }
}
